import { Location } from '@angular/common';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { first } from 'rxjs/operators';
import { ApiService } from 'src/_services/api.service';
import { TranslateService } from 'src/_services/translate.service';
import SignaturePad from '../../../assets/js/signature_pad.umd.min.js';
import { OwlDateTimeIntl } from 'ng-pick-datetime';
import { OwlDateTimeComponent } from 'ng-pick-datetime';
declare var $: any;

@Component({
  selector: 'app-family-allowance',
  templateUrl: './family-allowance.component.html',
  styleUrls: ['./family-allowance.component.scss']
})
export class FamilyAllowanceComponent implements OnInit {
  @ViewChild('canvas', { static: true }) canvas: ElementRef < HTMLCanvasElement > ;
  @ViewChild('dt49', { static: false }) dateTimePicker: OwlDateTimeComponent < Date > ;
  value: any;
  rsubmitted: boolean = false;
  responseFamilyAllowance: any;
  employees: any;
  employer: any;
  spouse: any;
  child: any;
  allowance_id: any;
  family_allowance_id: any;
  signatureResponse: any
  response: any;
  familyallowanceDetails: any;
  rejectReason: any;
  currentLang: any;
  showAll: boolean = false;
  signature: string | null = null;
  public todayDate: any = new Date();
  signaturePad: SignaturePad;
  minReportDate: Date = new Date();
  accountDetails: any;
  isSubmitted = false;
  constructor(private translate: TranslateService,
    private location: Location,
    private router: Router,
    private fb: FormBuilder,
    private api: ApiService,
    private owlDateTimeIntl: OwlDateTimeIntl,
    private route: ActivatedRoute,
    private ngxUiLoaderService: NgxUiLoaderService,
    private snackBar: MatSnackBar) {

    if (this.router.getCurrentNavigation().extras.state) {
      console.log(this.router.getCurrentNavigation().extras)
      this.value = this.router.getCurrentNavigation().extras.state.data;
      console.log("47", this.value)
      if (this.value == '3') {
        setTimeout(() => {
          $('#familyAllowanceModal').modal('show');
        }, 400)
      }
      if (this.value == '1') {
        this.getViewAllowanceReports();
      }
    } else {
      this.router.navigate(['/family-allowance-list'])
    }
    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);
      console.log(this.accountDetails)
    }
  }

  ngOnInit() {
    this.route.params.subscribe(data => {
      console.log("params", data);
      this.family_allowance_id = data['id'];
      console.log("idddddddd", this.family_allowance_id);
      if (this.family_allowance_id) {
        this.getViewAllowanceReports()
      }

    })
  }

  familyAllowanceForm = this.fb.group({
    year: ['', Validators.required]
  })

  // signatureForm = this.fb.group({
  //   signature: ['', Validators.required]
  // });
  ngAfterViewInit() {
    this.signaturePad = new SignaturePad(this.canvas.nativeElement);
    console.log("88", this.signaturePad)
    this.resizeCanvas();

  }
  addFamilyAllowance() {
    console.log("000", this.familyAllowanceForm);
    this.rsubmitted = true;
    if (this.familyAllowanceForm.invalid) {
      return;
    } else {
      this.ngxUiLoaderService.start();
      let data = this.familyAllowanceForm.value
      this.api.getemployeeAllowance(data).pipe(first()).subscribe(data => {
        this.ngxUiLoaderService.stop();
        console.log("work", data);
        this.responseFamilyAllowance = data
        if (this.responseFamilyAllowance.status == 200) {
          this.rsubmitted = false
          this.employees = this.responseFamilyAllowance.results.employee
          this.employer = this.responseFamilyAllowance.results.employer
          this.spouse = this.responseFamilyAllowance.results.spouse
          this.child = this.responseFamilyAllowance.results.child
          console.log("emp", this.employees);
          $('#familyAllowanceModal').modal('hide');

        } else {
          this.snackBar.open(this.responseFamilyAllowance.message, "OK", {
            duration: 5000,
          });
        }

      }, error => {
        this.rsubmitted = false;
        this.ngxUiLoaderService.stop();
      })
    }
  }

  get a() {
    return this.familyAllowanceForm.controls;
  }

  // get b() {
  //   return this.signatureForm.controls;
  // }

  goBack() {
    this.location.back();
  }

  closeModal() {
    $('#familyAllowanceModal').modal('hide');
    this.router.navigateByUrl('/family-allowance-list')
  }

  saveImage() {
    const data = this.signaturePad.toDataURL();
    if (!this.signaturePad.isEmpty()) {
      this.signature = data
      console.log(this.signaturePad.isEmpty());
    } else {
      console.log(data);
      console.log("is sig empty:", this.signaturePad.isEmpty());
    }
  }
  clearSignPad() {
    this.signaturePad.clear();
    this.signature = null;

  }


  onSubmit() {
    console.log('click');
    console.log('165', this.signature);
    if (this.accountDetails.current_user == 2) {
      this.isSubmitted = true
      if (!this.signature) {
        return
      }
    }

    let data = {
      signature: this.signature,
      allowance_id: this.employees.allowance_id
    };
    console.log(data);
    this.api.submitEmployeeAllowance(data).subscribe(response => {
      console.log(response);
      this.signatureResponse = response;
      if (this.signatureResponse.status == 200) {
        // this.formSubmitted = false;
        this.snackBar.open(this.signatureResponse.message, "OK", {
          duration: 5000,
        });
        this.router.navigate(["/family-allowance-list"])
      } else {
        this.snackBar.open(this.signatureResponse.message, "OK", {
          duration: 5000,
        });
      }
    });
  }

  getViewAllowanceReports() {
    this.ngxUiLoaderService.start();
    if (this.family_allowance_id) {
      var data = this.family_allowance_id;
      this.api.getViewAllowanceReports(data).pipe(first())
        .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data
          console.log(this.response);
          if (this.response.status == 200) {
            this.employees = this.response.results.employee;
            this.employer = this.response.results.employer;
            this.spouse = this.response.results.spouse;
            this.child = this.response.results.child;
            this.rejectReason = this.response.verification;
            this.signature = this.employees.signature;
          }
        })
    }

  }

  view() {
    this.showAll = !this.showAll;
    if (this.showAll) {
      console.log("244", this.currentLang)
      if (this.currentLang == 'fr') {
        $("#view").text('Voir plus')
      } else {
        $("#view").text('View more')
      }
    } else {
      console.log("252", this.currentLang)
      if (this.currentLang == 'fr') {
        $("#view").text('Voir moins')
      } else {
        $("#view").text('View less')
      }

    }
  }
  resizeCanvas() {
    console.log("237")
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const canvas = this.canvas.nativeElement;
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext('2d').scale(ratio, ratio);
    this.signaturePad.clear();
  }
  chosenYearHandler(e) {
    console.log(this.dateTimePicker);
    console.log(e);

    const initialDate = new Date(e);
    const extractedYear = initialDate.getFullYear();

    const minYear = this.minReportDate.getFullYear();
    const maxYear = this.todayDate.getFullYear();

    console.log(extractedYear);

    if (extractedYear >= minYear && extractedYear <= maxYear) {
      this.familyAllowanceForm.controls['year'].setValue(extractedYear);
    } else {
      console.warn('Selected year is out of range');
    }

    if (this.dateTimePicker) {
      this.dateTimePicker.close();
    }
  }

}
